import { Emitter, Event } from "../../../../../features/event-emitter"
import { TableName } from "../../../../../tables"
import { useSaleOperationService } from "../../../services/sale-operation-service/saleOperationService"

export const useActions = () => {
    const { bulkConfirmSalePayments } = useSaleOperationService()

    const confirmPayments = async (
        table: TableName,
        bulkDataTypeIds: string[],
        paymentTypeId: string,
        cashFundId: string,
        paymentDate: Date
    ) => {
        Emitter.emit(Event.DB_SUBMIT)
        await bulkConfirmSalePayments(table, bulkDataTypeIds, paymentTypeId, cashFundId, paymentDate)
        Emitter.emit(Event.DB_SUBMIT_DONE, false)
    }

    return {
        confirmPayments
    }
}
